import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Ng2SearchPipeModule } from 'ng2-search-filter';


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';
import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RestorePasswordComponent } from './views/restore-password/restore-password.component';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RegistroModule } from './registro/registro.module';
import { MsalModule, MsalInterceptor } from '@azure/msal-angular';
import { ToastrModule } from 'ngx-toastr';

const APP_CONTAINERS = [
  DefaultLayoutComponent 
  //LoginComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';

import { environment } from '../environments/environment';
import { MsalUserService } from './applicationinfraestructure/services/msaluser.service';
import { UsersData } from './applicationinfraestructure/interfaces/userData';
import { ValidateRedirectLogin } from './registro/guards/validar-redirect';
import { ValidarLogin } from './registro/guards/validar-login';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ValidarAdmin } from './registro/guards/validar-admin';
import { ValidarAdminCerticadas } from './registro/guards/validar-admin-certificado';
import { ValidarMarcaCertificada } from './registro/guards/validar-marca-certificada';
import { ValidarMarca } from './registro/guards/validar-marca';
import { ValidarAdminPermisos }from './registro/guards/validar-admin-permisos';
import { MatStepperModule } from '@angular/material/stepper'
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { EmailVerificationComponent } from './views/email-verification/email-verification.component';
import { UpdateUserComponent } from './views/user/update-user/update-user.component';

export const protectedResourceMap: any =
  [
    [environment.baseUrl, environment.scopeUri
    ]
  ];

@NgModule({
  imports: [
    MsalModule.forRoot({
      clientID: environment.uiClienId,
      authority: 'https://login.microsoftonline.com/' + environment.tenantId,
      protectedResourceMap: protectedResourceMap,
      redirectUri: environment.redirectUrl
    }),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),

    RegistroModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    Ng2SearchPipeModule,
    FormsModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    P404Component,
    P500Component,
    LoginComponent,
    RestorePasswordComponent,
    EmailVerificationComponent,
    UpdateUserComponent,
    
    
  ],
  providers: [
    UsersData,
    MsalUserService,
    ValidateRedirectLogin,
    ValidarLogin,
    ValidarAdmin,
    ValidarAdminCerticadas,
    ValidarMarcaCertificada,
    ValidarMarca,
    ValidarAdminPermisos,
   
    {
      provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
  }],
  bootstrap: [ AppComponent ],
  entryComponents: [EmailVerificationComponent,
    UpdateUserComponent
  ],
})
export class AppModule { }
